/* tslint:disable:indent */
// Angular
import {Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'app-dialog-confirmation',
	templateUrl: './dialog-confirmation.component.html',
	styleUrls: ['./dialog-confirmation.component.scss']
})
export class DialogConfirmationComponent {

	constructor(
		public dialogRef: MatDialogRef<DialogConfirmationComponent>,
		@Inject(MAT_DIALOG_DATA) public data: {
			message: ''
		}
	) { }

	onOkClick(): void {
		this.dialogRef.close(1);
	}

	onCancelClick(): void {
		this.dialogRef.close(0);
	}

}
